export default __webpack_public_path__ + "static/media/duplicate-white.024f5cf8.png";